module.exports = __webpack_public_path__ + "img/banner_logo_2d.6e06c9e1.svg";